import { mergeCartPage } from './mergeCartPage';
import { cartHasItems } from '../_pages/order-review/cartHasItems';

const pkg = (id) => ({ id, package: { name: `Package ${id}` } });

describe('mergeCartPage', () => {
  it('takes the incoming cart when we hold nothing yet', () => {
    const incoming = { id: 1, orderPackages: [pkg(10), pkg(11)] };

    expect(mergeCartPage(null, incoming)).toBe(incoming);
    expect(mergeCartPage(undefined, incoming)).toBe(incoming);
    expect(mergeCartPage({}, incoming)).toBe(incoming);
  });

  it('appends a later page to the packages already held', () => {
    const held = { id: 1, subtotal: 10, orderPackages: [pkg(10), pkg(11)] };
    const incoming = { id: 1, subtotal: 30, orderPackages: [pkg(12)] };

    const merged = mergeCartPage(held, incoming);

    expect(merged.orderPackages.map((op) => op.id)).toEqual([10, 11, 12]);
  });

  it('takes updated totals from the incoming page', () => {
    const held = { id: 1, subtotal: 10, apiTotal: 10, orderPackages: [pkg(10)] };
    const incoming = { id: 1, subtotal: 89.98, apiTotal: 78.01, orderPackages: [] };

    const merged = mergeCartPage(held, incoming);

    expect(merged.subtotal).toBe(89.98);
    expect(merged.apiTotal).toBe(78.01);
  });

  it('does not duplicate a package that arrives on two pages', () => {
    const held = { id: 1, orderPackages: [pkg(10), pkg(11)] };
    const incoming = { id: 1, orderPackages: [pkg(11), pkg(12)] };

    const merged = mergeCartPage(held, incoming);

    expect(merged.orderPackages.map((op) => op.id)).toEqual([10, 11, 12]);
  });

  it('returns what we hold when the fetch produced nothing', () => {
    const held = { id: 1, orderPackages: [pkg(10)] };

    expect(mergeCartPage(held, null)).toBe(held);
    expect(mergeCartPage(held, undefined)).toBe(held);
  });

  // THE REGRESSION. Packages page 5-at-a-time, so the final request of every
  // cart returns an empty page. Assigning that page straight onto the context
  // cart emptied orderPackages, cartHasItems() went false, and the review
  // page's primary checkout CTA vanished while the item list still rendered.
  it('keeps the cart non-empty when the final page comes back empty', () => {
    const held = { id: 1, orderPackages: [pkg(10), pkg(11)] };
    const emptyFinalPage = { id: 1, subtotal: 89.98, orderPackages: [] };

    const merged = mergeCartPage(held, emptyFinalPage);

    expect(merged.orderPackages).toHaveLength(2);
    expect(cartHasItems({ cart: merged })).toBe(true);
  });

  it('reproduces the bug when the raw page is used instead of the merge', () => {
    const emptyFinalPage = { id: 1, orderPackages: [] };

    // What the code used to hand to setCustomer.
    expect(cartHasItems({ cart: emptyFinalPage })).toBe(false);
  });

  // The other half of the contract, enforced by the CALLER rather than here:
  // merging is append-only, so it can never drop a package the server has
  // deleted. That is why page 1 REPLACES instead of merging -- see the fetch in
  // CustomerCart/index.jsx. This documents the limitation so nobody "fixes" the
  // caller back into merging page 1.
  it('does NOT drop a package the incoming page omits', () => {
    const held = { id: 1, orderPackages: [pkg(10), pkg(11)] };
    const serverNoLongerHas11 = { id: 1, orderPackages: [pkg(10)] };

    const merged = mergeCartPage(held, serverNoLongerHas11);

    expect(merged.orderPackages.map((op) => op.id)).toEqual([10, 11]);
  });
});
